import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,
    TableContainer, Table, TableHead, TableBody, TableRow, TableCell,
} from "@mui/material";
import { formatMilkingTime, milkingSlots } from "../../utils/milk-recording-checks.js";

const MilkRecordingConfirmation = ({ values, ownerName, onCancel, onConfirm }) => {
    const checks = values?.checks || [];
    const scheduled = checks.filter((check) => check.time);
    const measured = checks.filter((check) => check.checked);
    return (
        <Dialog open={Boolean(values)} onClose={onCancel} fullWidth maxWidth="sm"
            aria-labelledby="milk-recording-confirmation-title">
            <DialogTitle id="milk-recording-confirmation-title">
                Επιβεβαίωση προγράμματος και μετρήσεων άμελξης
            </DialogTitle>
            <DialogContent>
                <Typography>{ownerName}</Typography>
                {values && (
                    <Typography sx={{ mb: 2 }}>
                        Ημερομηνία ελέγχου: {new Date(values.testDate).toLocaleDateString("el-GR", { timeZone: "Europe/Athens" })}
                    </Typography>
                )}
                <Typography>
                    Η εκτροφή πραγματοποιεί {scheduled.length} αμέλξεις καθημερινά.
                    Στον συγκεκριμένο έλεγχο δηλώθηκαν μετρήσεις για {measured.length} από αυτές.
                </Typography>
                <TableContainer sx={{ my: 2 }}>
                    <Table size="small" aria-label="Πρόγραμμα άμελξης και μετρήσεις ελέγχου">
                        <TableHead>
                            <TableRow>
                                <TableCell>Άμελξη</TableCell>
                                <TableCell>Ώρα στην εκτροφή</TableCell>
                                <TableCell>Μετρήθηκε στον έλεγχο</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {milkingSlots.map(({ type, label }) => {
                                const check = checks.find((item) => item.type === type);
                                return (
                                    <TableRow key={type}>
                                        <TableCell component="th" scope="row">{label}</TableCell>
                                        <TableCell>{check?.time ? formatMilkingTime(check.time) : "Δεν πραγματοποιείται"}</TableCell>
                                        <TableCell>{check?.checked ? "Ναι" : "Όχι"}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Typography>
                    Θα ζητηθούν ποσότητες γάλακτος ανά ζώο μόνο για τις αμέλξεις που δηλώθηκαν ως μετρημένες:
                    {" "}{milkingSlots.filter(({ type }) => measured.some((check) => check.type === type))
                        .map(({ label }) => label).join(", ")}.
                </Typography>
                <Typography sx={{ mt: 1 }}>
                    {measured.length === scheduled.length
                        ? "Μετρήθηκαν όλες οι καθημερινές αμέλξεις. Το άθροισμα των ποσοτήτων τους αντιστοιχεί στην ημερήσια παραγωγή."
                        : "Πρόκειται για μερική μέτρηση της ημέρας. Οι ποσότητες που καταχωρούνται δεν αποτελούν από μόνες τους την πλήρη ημερήσια παραγωγή."}
                </Typography>
                <Typography sx={{ mt: 1 }}>
                    Για μερική μέτρηση, η ημερήσια παραγωγή θα εκτιμηθεί από τις ποσότητες
                    και τις ώρες αυτού του ελέγχου με τον υπολογισμό του παλιού συστήματος Αμνός.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2, flexWrap: "wrap", gap: 1 }}>
                <Button onClick={onCancel}>Πίσω για διόρθωση</Button>
                <Button variant="contained" onClick={onConfirm}>Επιβεβαίωση και αποθήκευση</Button>
            </DialogActions>
        </Dialog>
    );
};

export default MilkRecordingConfirmation;
